import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import styles from './ProductAndPriceInfo.module.scss';

type Props = {
  title: string;
  price: number;
  discountPrice: number;
  authorLink: string;
  author: string;
  ageInfo: string;
  isPurchased: boolean;
  className?: string;
  // Блок рендерится дважды (мобильная и десктопная раскладки), h1 — только у одной копии
  titleTag?: 'h1' | 'div';
};

export const ProductAndPriceInfo: React.FC<Props> = ({
  title,
  price,
  discountPrice,
  authorLink,
  author,
  ageInfo,
  className,
  isPurchased,
  titleTag = 'h1',
}) => {
  const { t } = useTranslation();
  const TitleTag = titleTag;

  return (
    <div className={cn(styles.productInfoContainer, className)}>
      <div className={styles.productTitleAndPrice}>
        <TitleTag className={styles.productTitle}>{title}</TitleTag>
        {!isPurchased && (
          <div className={styles.productPrices}>
            <div
              className={cn(styles.productPrice, {
                [styles.productPriceCrossedOut]:
                  discountPrice || (discountPrice === 0 && price !== 0),
              })}
            >
              {price}&#36;
            </div>
            {(discountPrice || (discountPrice === 0 && price !== 0)) && (
              <div className={styles.productDiscountPrice}>{discountPrice}&#36;</div>
            )}
          </div>
        )}
      </div>
      <div className={styles.productAuthorAndAgeInfo}>
        <Link to={authorLink} className={styles.productAuthor}>
          {t('product.authorTitle')} {author}
        </Link>
        <div className={styles.productYears}>{ageInfo}</div>
      </div>
    </div>
  );
};
